import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchMiscLedger,
  createMiscLedger,
  type ListMiscLedgerQuery,
  type CreateMiscLedgerPayload,
} from '@/services/api/miscLedger.api';

export function useMiscLedger(query: ListMiscLedgerQuery, enabled = true) {
  return useQuery({
    queryKey: ['misc-ledger', query],
    queryFn: () => fetchMiscLedger(query),
    staleTime: 30_000,
    enabled: enabled && !!query.propertyId,
  });
}

export function useCreateMiscLedger() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateMiscLedgerPayload) => createMiscLedger(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['misc-ledger'] });
    },
  });
}
